import { TextField, useTheme } from '@mui/material';
import React from 'react';
import { useDarkMode } from '../../../../../hooks/useDarkMode';

interface NameFieldProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
}

export const NameField: React.FC<NameFieldProps> = ({
  value,
  onChange,
  label = 'Name',
  placeholder,
  disabled = false,
}) => {
  const theme = useTheme();
  const { customColorPalette: palette } = theme;
  const isDarkMode = useDarkMode();

  return (
    <TextField
      fullWidth
      label={label}
      placeholder={placeholder}
      variant='outlined'
      value={value}
      onChange={e => onChange(e.target.value)}
      disabled={disabled}
      sx={{
        '& .MuiOutlinedInput-root': {
          backgroundColor: isDarkMode ? palette.gray[800] : '#FFFFFF',
          color: isDarkMode ? palette.gray.A100 : palette.gray[900],
        },
      }}
    />
  );
};
